function getNidInquiryStatusClassLine(type) {
  let result = "";
  switch (type) {
    case 'All':
      return "not identity-verified";
     
    case 'Accepted':
      return "identity-verified";
     
    case 'ReadyForInquiry':
      return "not identity-verified";
     
    case 'InProgress':
      return "not identity-verified";
     
    case 'Rejected':
      return "revoked identity-verified";
     
    default:
      return "";
     
  }
 
}
export default getNidInquiryStatusClassLine;